import { Component, FormEvent, ReactNode } from 'react';

export type FieldStatus = 'disabled' | 'read-only' | 'success' | 'error' | null;

export type UncontrolledField<V> = {
    id?: string,
    name?: string,
    value?: V,
    disabled?: boolean,
    status?: FieldStatus
};

export type BraxUncontrolledFormProps = {
    id?: string,
    className?: string,
    children: ReactNode,
    onSubmit?: (event: FormEvent<HTMLFormElement>) => void
};

export class BraxUncontrolledForm extends Component<BraxUncontrolledFormProps> {

    static defaultProps = {
        values: {}
    };

    onSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();

        if (this.props.onSubmit)
           this.props.onSubmit(event);
    }

    render() {
        return (
            <form id={this.props.id} className={`brax-form ${this.props.className || ''}`} onSubmit={event => this.onSubmit(event)}>
                { this.props.children }
            </form>
        );
    }

}

export * from './BraxUncontrolledAutocompleteField';
export * from './BraxUncontrolledCheckboxField';
export * from './BraxUncontrolledColorPickerField';
export * from './BraxUncontrolledDateTimeField';
export * from './BraxUncontrolledFileField';
export * from './BraxUncontrolledNPSField';
export * from './BraxUncontrolledPasswordField';
export * from './BraxUncontrolledPhoneField';
export * from './BraxUncontrolledRadioField';
export * from './BraxUncontrolledRadioToggleButtonField';
export * from './BraxUncontrolledRangeField';
export * from './BraxUncontrolledSearchField';
export * from './BraxUncontrolledSelectField';
export * from './BraxUncontrolledSwitchField';
export * from './BraxUncontrolledTextAreaField';
export * from './BraxUncontrolledTextField';
export * from './BraxUncontrolledUploadBoxField';
